import React from 'react';
import Routing from './route/Routing';
import './App.css';

const App = () => {
  return (
    <div>
      <Routing />
    </div>
  );
}

export default App;
